// import React, { Component } from "react";
// import { connect } from "react-redux";
// import _ from "lodash";
// import { Row, Col, FormGroup, Radio } from "react-bootstrap";
// import Button from "react-bootstrap-button-loader";
// import LocaleStrings from "Languages";

import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
// import TemplateEditor from "./grape";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import Button from "react-bootstrap-button-loader";
import Iframe from "react-iframe";
import { Row, Col, FormGroup, Radio } from "react-bootstrap";
import GrapesmodalContent from "../pages/grapesmodal";
import LocaleStrings from "Languages";
import { Field, reduxForm, reset } from "redux-form";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
// import "grapesjs/dist/css/grapes.min.css";
import { saveTitleandurl } from "../../actions";

class ChangeTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, id: 0, section: "" };
    // this.onSubmitForm = this.onSubmitForm.bind(this);
    // this.state = { loading: false, showModal: false };
  }
  // openModals = (pageid) => this.setState({ isOpen: true, id: pageid});
  // closeModals = () => this.setState({ isOpen: false });

  openModals = (section) => {
    // this.setState({ isOpen: true, id: pageid });
    this.setState({ isOpen: true, section: section });
    // let section = response.result.resource[0].section;
  };
  closeModals = () => this.setState({ isOpen: false });

  openModal = () => {
    // this.props.reset();
    this.setState({ loading: false, showModal: true });
  };

  closeModal = () => {
    // this.props.reset();
    this.setState({ showModal: false });
  };

  viewSite = (e) => {
    // let { siteDetails } = this.props;

    let siteURL = "http://staging.teks.co.in/udayan/preview/index";
    // "https://" + siteDetails.resource[0].website_subdomain + ".eventify.io";

    window.open(siteURL, "_blank");
  };

  render() {
    return (
      <Row>
        <div className="row">
          <div className="col-md-4 card-template">
            <img
              src="../../style/images/header-icons/themes.png"
              className="default-theme"
              onClick={this.openModal}
            />
          </div>
          <Modal
            className="modal-container"
            show={this.state.showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
          >
            {/* <form
            onSubmit={handleSubmit(this.onSubmitForm)}
            encType="multipart/form-data"
          > */}
            <Modal.Header>
              <div className="import-modal-title">Web Template</div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={this.closeModal}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              {/* <TitleUrl {...this.props} /> */}
              <div className="warning">Warning !!!</div>
              <div className="warning-message">
                Are you sure you want to change your theme?
              </div>
              <div className="warning-message">
                {" "}
                Changing template will delete all the changes you’ve made (eg.
                Color, Fonts, Texts, Images) and will be replaced to the default
                state.
              </div>
            </Modal.Body>
            <Modal.Footer>
              {/* <Button
                className="btn-custom-blue ml-10"
                
                loading={this.state.loading}
                // disabled={pristine || invalid || submitting}
                type="submit"
              >
                Change
              </Button> */}
              <Button
                className="btn-custom-blue ml-10"
                loading={this.state.loading}
                // onClick={() => this.openModals("newpage")}
                // onClick={this.closeModal}
                // disabled={pristine || invalid || submitting}
                onClick={(e) => this.viewSite()}
                type="submit"
              >
                Preview
              </Button>
              <Button
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
            </Modal.Footer>
            {/* </form> */}
          </Modal>
        </div>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  // let initVals = {};
  return {
    session: state.session,
    // initialValues: initVals,
  };
}

export default connect(mapStateToProps)(ChangeTemplate);
